<template>
  <div id="topbar">
    <div class="topbar">
        <button @click="exit">Se déconnecter</button>
        <router-link :to="{ name:'myMatchs'}"><button>Mon compte</button></router-link>
        <h3 id="username" v-if="currentUser">{{currentUser.username}}</h3>
        <h3 v-else>Username not found</h3>
    </div>
  </div>
</template>

<script>
import store from '../store/index.js'
import { mapGetters } from 'vuex'

export default {
  name: 'topbar',
  computed:
  {
    ...mapGetters([
      'evenOrOdd',
      'currentUser'
    ]),
    count () {
      return store.state.count
    }
  },
  methods: {
    exit () {
      store.dispatch('logOut')
      this.$router.push({name: 'Home'})
    }
  },
  data () {
    return {
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div[data-popover="notifications"] {
  background: #E9EBEE;
  color: #555555;
  text-color: #555555;
  margin-left:0;
  margin-right:0;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.notif-hr {
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
}
.notif-row {
    padding-left: 0;
    padding-right: 0;
}
.topbar {
    background: #003366;
    color: #ffffff;
    padding-left: 1rem;
    padding-top: 0.3rem;
    padding-bottom: 0.1rem;
    border: none;
    font-weight: 400;
}

.topbar button {
    margin: 0.6rem;
    float: right;
    font-size: 0.8em;

}

.topbar h3 {
    font-weight: 200;
    font-size: 1.8em;
    text-align:left;
}

.icon {
    max-width:50%;
    max-height:50%;
    margin-top:0;
    margin: 0;
    background-color: rgba(0,0,0,0);
}

.icon:hover {
    background-color: rgba(0,0,0,1);
}
</style>



// WEBPACK FOOTER //
// topbar.vue?5e8511c2